import type { FC } from "react";
import { useTranslation } from "react-i18next";

import { TitleStyle } from "../../../../../core/styles/TextStyles";

interface PageTitleProps {
    translationKey: string;
}

export const PageTitle: FC<PageTitleProps> = ({ translationKey }) => {
    const { t } = useTranslation();

    return <TitleStyle>{t(translationKey)}</TitleStyle>;
};
